import { render } from "./DataLazy.vue?vue&type=template&id=549e58b8"
import script from "./DataLazy.vue?vue&type=script&lang=js"
export * from "./DataLazy.vue?vue&type=script&lang=js"

import "./DataLazy.vue?vue&type=style&index=0&id=549e58b8&lang=scss"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__